import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { IoClose } from 'react-icons/io5';
import { imageSrc } from '../utils/avatar';
import { useLanguage } from '../i18n/LanguageContext';
import '../style/Profile.css';

// A photo at full size (the 512px variant, animated if it is). Closes on a
// click anywhere, the close button, or Esc.
export default function ImageLightbox({ imageUrl, alt, onClose }) {
  const { t } = useLanguage();
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return createPortal(
    <div className="ImageLightbox" role="dialog" aria-label={alt || ''} onClick={onClose}>
      <button type="button" className="ImageLightboxClose" onClick={onClose} aria-label={t('common.close')}><IoClose /></button>
      <img src={imageSrc(imageUrl, { size: 512, animated: true })} alt={alt || ''} />
    </div>,
    document.body
  );
}
